import { render, staticRenderFns } from "./ManagePictureBook.vue?vue&type=template&id=9049e164&"
import script from "./ManagePictureBook.vue?vue&type=script&lang=js&"
export * from "./ManagePictureBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports